var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#DE2910"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23369 8.37848L11.838 16.3938L5.01978 11.4401H13.4476L6.62935 16.3938L9.23369 8.37848Z",
    fill: "#FFDE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1962 7.01932L16.9496 9.81775L15.5042 7.40881L18.0895 8.50812L15.3518 9.13834L17.1962 7.01932Z",
    fill: "#FFDE00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6323 10.304L19.3191 12.7874L18.9218 10.0064L20.8779 12.0227L18.1102 11.5412L20.6323 10.304Z",
    fill: "#FFDE00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9597 15.2567L18.7476 16.9883L19.5194 14.2871L20.4827 16.9261L18.1522 15.3574L20.9597 15.2567Z",
    fill: "#FFDE00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1395 17.335L17.0091 20.1412L15.4651 17.7943L18.0937 18.7855L15.3846 19.5287L17.1395 17.335Z",
    fill: "#FFDE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCny);
export default __webpack_public_path__ + "static/media/cny.4863413eb3203f37daf6e9b6f434d7f9.svg";
export { ForwardRef as ReactComponent };